export const CUSTOM_FIELDS_SET = 'at/customFields/CUSTOM_FIELDS_SET'



// WEBPACK FOOTER //
// ./web/js/customFields/actionTypes.js